document.addEventListener("DOMContentLoaded", () => {
    const body_classnames = document.body.className;

    // Bootstrap breakpoints.
    const breakpoints = {
        sm:  576,
        md:  768,
        lg:  992,
        xl:  1280,
        xxl: 1550
    };

    // Global
    (() => {
        // Hamburger show menu
        const site_header = document.getElementById("site-header");
        if (site_header) {
            const site_menu_container = site_header.querySelector(".site-navigation");
            const hamburger = site_header.querySelector("#site-hamburger");

            hamburger.addEventListener("click", () => {
                site_menu_container.classList.toggle("-active");
                hamburger.classList.toggle("-active");
            });
        }

        // Sticky header
        // Define sticky header scroll breakpoint.
        let sticky_header_scroll_breakpoint = site_header.offsetTop;

        if (document.body.classList.contains("admin-bar")) {
            if (screen.width > 782) {
                sticky_header_scroll_breakpoint -= 32;
            } else if (screen.width > 600) {
                sticky_header_scroll_breakpoint -= 46;
            }
        }

        /**
         * Refreshes classes of sticky header.
         */
        function refresh_sticky_header_classes() {
            if (window.scrollY > sticky_header_scroll_breakpoint) {
                site_header.classList.add("sticky");
            } else {
                site_header.classList.remove("sticky");
            }
        }

        window.addEventListener("scroll", refresh_sticky_header_classes);
        setTimeout(refresh_sticky_header_classes, 50);
    })();


    // Home scripts
    (() => {
        if (!["home"].some(css_class => body_classnames.includes(css_class))) return;
        // Embla carousel

        const heroSection = document.querySelector('.hero');
        const wrap = document.querySelector(".embla");
        const viewPort = wrap.querySelector(".embla__viewport");
        const prevBtn = wrap.querySelector(".embla__button--prev");
        const nextBtn = wrap.querySelector(".embla__button--next");
        const embla = EmblaCarousel(viewPort, { align: 'start' });
        const dots = heroSection.querySelector(".embla__dots");

        prevBtn.addEventListener('click', () => {
            embla.scrollPrev()
            selectDotBtn()
        })

        nextBtn.addEventListener('click', () => {
            embla.scrollNext()
            selectDotBtn()
        })

        function generateDotBtns() {
            const template = document.getElementById("embla-dot-template").innerHTML;
            dots.innerHTML = embla.scrollSnapList().reduce(acc => acc + template, "");
            return [].slice.call(dots.querySelectorAll(".embla__dot"));
        }

        function setupDotBtns() {
            const dotsArray = heroSection.querySelectorAll('.embla__dot');
            dotsArray.forEach((dotNode, i) => {
                dotNode.addEventListener("click", () => embla.scrollTo(i), false);
            });
        }

        function selectDotBtn() {
            const dotsArray = heroSection.querySelectorAll('.embla__dot');
            const previous = embla.previousScrollSnap();
            const selected = embla.selectedScrollSnap();
            console.log(previous)
            dotsArray[previous].classList.remove("is-selected");
            dotsArray[selected].classList.add("is-selected");
        }

        generateDotBtns()
        setupDotBtns()
        selectDotBtn()
    })();

    // Home scripts
    (() => {
        if (!["single-kmbss_product"].some(css_class => body_classnames.includes(css_class))) return;

        // Embla carousel
        const wrap = document.querySelector(".embla");

        if (wrap) {
            const viewPort = wrap.querySelector(".embla__viewport");
            const prevBtn = wrap.querySelector(".embla__button--prev");
            const nextBtn = wrap.querySelector(".embla__button--next");
            const embla = EmblaCarousel(viewPort, {align: 'start'});

            prevBtn.addEventListener('click', embla.scrollPrev, false);
            nextBtn.addEventListener('click', embla.scrollNext, false);
        }

        // Gallery
        const elements = document.querySelectorAll('.gallery a')
        if (elements.length < 0) {
            return
        }

        new SimpleLightbox({
            elements
        });

        // Buttons listeners
        const spec_button = document.querySelector('.specification-button');
        const files_button = document.querySelector('.btn-files');
        const table = document.querySelector('.specification-table');
        const files = document.querySelector('.files');

        if (spec_button) {
            spec_button.addEventListener('click', displayTable, false);
        }

        if (files_button) {
            files_button.addEventListener('click', displayFiles, false);
        }

        function displayTable() {
            table.classList.add('active');
            files.classList.remove('active');
            spec_button.classList.add('active');
            files_button.classList.remove('active')
        }

        function displayFiles() {
            table.classList.remove('active');
            files.classList.add('active');
            spec_button.classList.remove('active');
            files_button.classList.add('active');
        }

        // Date picker
        const dateFrom = document.getElementById('dateFrom');
        const dateTo = document.getElementById('dateTo');
        const dateFromBtn = document.getElementById('dateFromBtn');
        const dateToBtn = document.getElementById('dateToBtn');

        dateFrom.addEventListener('focus', (event) => {
            event.currentTarget.showPicker();
        })

        dateTo.addEventListener('focus', (event) => {
            event.currentTarget.showPicker();
        })

        dateFromBtn.addEventListener('click', () => {
            dateFrom.showPicker();
        })

        dateToBtn.addEventListener('click', () => {
            dateTo.showPicker();
        })
    })();

    const maps = document.querySelectorAll(".acf-map");

    for (const map of maps) {
        new IM_Google_Map(map);
    }
});
